module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00077.5da2ce17.jpg";